import FormattedMessage from 'I18n/components/FormattedMessage';
import { CardGrid } from 'foundations-components/transitional/components/CardGrid';
import { DashboardPage } from 'foundations-components/transitional/components/DashboardPage';
import { GET_ALL_PUBLISHED_COLLECTIONS_QUERY as GET_ALL_PUBLISHED_COLLECTIONS_QUERY_PUBLIC } from '../../__generated__/chirp/com/hubspot/marketplace/quality/rpc/SelfServePublicRpc.dfc.new';
import { GET_ALL_PUBLISHED_COLLECTIONS_QUERY } from '../../__generated__/chirp/com/hubspot/marketplace/quality/rpc/SelfServeRpc.dfc.new';
import { useAppContextQuery } from '../hooks/useAppContextQuery';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { useResponsiveProps } from 'marketplace-ui-common/hooks/useResponsiveProps';
import { UsageScreenProvider } from 'marketplace-ui-tracking';
import { NavMarker } from 'react-rhumb';
import { CollectionCard } from '../components/CollectionCard';
import { BaseHeader } from '../components/headers/BaseHeader';
import { Screens } from '../constants/usage';
import { jsx as _jsx } from "react/jsx-runtime";
export function FeaturedPage() {
  var _data$result;
  const {
    data,
    loading,
    error
  } = useAppContextQuery({
    app: GET_ALL_PUBLISHED_COLLECTIONS_QUERY,
    public: GET_ALL_PUBLISHED_COLLECTIONS_QUERY_PUBLIC
  });
  const {
    isMobile
  } = useResponsiveProps({
    isMobile: {
      xs: true,
      lg: false
    }
  });
  const collections = (data === null || data === void 0 || (_data$result = data.result) === null || _data$result === void 0 || (_data$result = _data$result.collections) === null || _data$result === void 0 ? void 0 : _data$result.filter(collection => collection.displayed !== false)) || [];
  return /*#__PURE__*/_jsx(NavMarker, {
    name: "FEATURED_LOAD",
    children: /*#__PURE__*/_jsx(UsageScreenProvider, {
      screen: Screens.FEATURED,
      children: /*#__PURE__*/_jsx(DashboardPage, {
        headerComponent: /*#__PURE__*/_jsx(BaseHeader, {
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplaceStorefront.featured.title"
          }),
          pathKey: "FEATURED",
          dataTestId: "featured-page-header"
        }),
        children: loading ? /*#__PURE__*/_jsx(LoadingSpinner, {
          grow: true,
          size: "medium",
          marginBlockStart: "800"
        }) : error ? /*#__PURE__*/_jsx(ErrorMessage, {
          type: "badRequest"
        }) : /*#__PURE__*/_jsx(CardGrid, {
          columns: isMobile ? 1 : 2,
          gap: "400",
          children: collections.map((collection, index) => /*#__PURE__*/_jsx(CollectionCard, {
            description: collection.description,
            name: collection.name,
            slug: collection.slug,
            previewItems: collection.previewItems,
            totalItemCount: collection.itemCount
          }, `${collection.slug}-${index}`))
        })
      })
    })
  });
}